import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import ServiceWidget from './ServiceWidget';

function Home() {
    return <React.Fragment>
          <img src="/images/neptune.png" style={{width:"100%"}} />
          <ServiceWidget />
    </React.Fragment>
}

export default Home;